import { useMemo, useState } from 'react'
import type { PropsWithChildren } from 'react'
import type { BreadcrumbItem } from '@mysaiva/core/components'

import { BreadcrumbContext } from './useWorkspaceBreadcrumb'

export function BreadcrumbProvider({ children }: PropsWithChildren) {
  const [override, setOverride] = useState<BreadcrumbItem[] | null>(null)
  const value = useMemo(() => ({ override, setOverride }), [override])
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>
}
